import { InjectionToken } from '@angular/core';
import { ICoreConfig } from './core.config.model';

export const CoreConfig: InjectionToken<ICoreConfig> = new InjectionToken('coreConfig');




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/models/core.config.ts